/**
 * Centralized localization configuration
 *
 * This file centralizes language and country settings that were previously
 * hardcoded throughout the application. Default values are set to 'FI'
 * but can be easily changed or made dynamic in the future.
 */

export interface LocalizationConfig {
  language: string;
  country: string;
}

/**
 * Default localization configuration
 */
export const DEFAULT_LOCALIZATION_CONFIG: LocalizationConfig = {
  language: 'FI',
  country: 'FI',
};

// Global reference to the current localization config
// This will be updated by the LocalizationContext
let globalLocalizationConfig: LocalizationConfig = { ...DEFAULT_LOCALIZATION_CONFIG };

/**
 * Internal function to update the global config
 * This should only be called by the LocalizationContext
 */
export const _updateGlobalLocalizationConfig = (config: LocalizationConfig): void => {
  globalLocalizationConfig = { ...config };
};

/**
 * Helper function to get the current language
 * This now returns the dynamic language from the context when available
 */
export const getCurrentLanguage = (): string => {
  return globalLocalizationConfig.language;
};

/**
 * Helper function to get the current country
 * This now returns the dynamic country from the context when available
 */
export const getCurrentCountry = (): string => {
  return globalLocalizationConfig.country;
};

/**
 * Helper function to get both language and country
 */
export const getLocalizationConfig = (): LocalizationConfig => {
  return {
    language: getCurrentLanguage(),
    country: getCurrentCountry(),
  };
};
